import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { LeanTerm } from './lean-term';


export class FormField extends BaseEntity{
    
    formCode    : string;
    fieldCode   : string;
    name        : string;
    tableName   : string;
    rank        : number;
    fieldType   : string;
    fieldStyle  : string;
    readOnly    : boolean;
    insertOnly  : boolean;
    term        : LeanTerm;
  
}